module.exports = __webpack_public_path__ + "img/zanorari27.dd3b6408.jpg";